import React from "react";
import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { injectIntl } from "react-intl";
import { RedCircleIcon } from "../../../common/icons";

const NavigationConfirmationModal = ({
  intl,
  open,
  title,
  message,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  onCloseIconClick,
  Icon = RedCircleIcon,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? null : onCloseIconClick || onSecondaryClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          width: "300px",
          backgroundColor: "#FFFFFF",
          position: "relative",
          borderRadius: "16px",
          padding: "16px 0 24px 0",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <button
          onClick={isLoading ? null : onCloseIconClick || onSecondaryClick}
          aria-label={"Fechar"}
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            background: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            fontSize: "20px",
            color: "#333",
            padding: "4px",
            lineHeight: 1,
            width: "40px",
            height: "40px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </DialogTitle>
      <DialogContent
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "0 24px",
          overflow: "hidden",
        }}
      >
        <Icon
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "24px",
          }}
        />
        <p
          style={{
            fontWeight: 700,
            color: "#1E293B",
            fontFamily: "'Ubuntu', Arial, sans-serif",
            fontSize: "20px",
            textAlign: "center",
            margin: "0 0 24px 0",
            lineHeight: "1.2",
          }}
        >
          {title}
        </p>
        {message && (
          <p
            style={{
              fontWeight: 400,
              color: "#33323D",
              fontFamily: "'Ubuntu', Arial, sans-serif",
              fontSize: "14px",
              textAlign: "center",
              margin: "0 0 24px 0",
              lineHeight: "1.4",
            }}
          >
            {message}
          </p>
        )}
        {primaryButtonText && (
          <Button
            style={{
              height: "48px",
              width: "100%",
              maxWidth: "252px",
            }}
            className="v3-button black"
            onClick={() =>
              !isLoading &&
              typeof onPrimaryClick === "function" &&
              onPrimaryClick()
            }
            color="primary"
            disabled={isLoading}
          >
            {primaryButtonText}
          </Button>
        )}

        {secondaryButtonText && (
          <Button
            style={{
              height: "48px",
              width: "100%",
              maxWidth: "252px",
              marginTop: "24px",
            }}
            className="v3-button"
            onClick={() =>
              !isLoading &&
              typeof onSecondaryClick === "function" &&
              onSecondaryClick()
            }
            color="primary"
            disabled={isLoading}
          >
            {secondaryButtonText}
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default injectIntl(NavigationConfirmationModal);
